import React from 'react';

interface LabelProps {
	children?: React.ReactNode;
}

export const Label: React.FC<LabelProps> = props => (
	<p className="-mb-5 mt-3 leading-4">{props.children}</p>
);
